module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/nu-9deebec59d90dece17fc9c87e82b6ff0.svg";